export default "__VITE_ASSET__DzhR_GKj__"